var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodiebag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.378 12.635H8.053a2.318 2.318 0 00-1.546.508c-.436.35-.73.847-.827 1.398L2.374 37.463a2.229 2.229 0 00.659 1.707 2.243 2.243 0 001.716.646h29.933a2.247 2.247 0 002.227-1.43c.114-.293.163-.608.146-.923l-3.306-22.922a2.305 2.305 0 00-.826-1.397 2.318 2.318 0 00-1.545-.51zM25.808 7.008c-.272-1.316-1.03-2.503-2.142-3.358a6.541 6.541 0 00-3.96-1.33 6.538 6.538 0 00-3.94 1.323c-1.11.849-1.868 2.028-2.145 3.336",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.402 22.476l-5.83 7.5-3.545-3.42",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgGoodiebag;